import { CheckCircle2 } from "lucide-react";

/**
 * Completion screen shown after all interview questions are answered.
 *
 * - Success animation (checkmark)
 * - "Thank You" message
 * - No CTA — the team manually generates the strategy
 */
export function InterviewComplete() {
	return (
		<div className="h-full flex flex-col items-center justify-center px-6">
			<div className="text-center space-y-6 max-w-md">
				{/* Success animation */}
				<div className="flex items-center justify-center">
					<div className="h-20 w-20 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center animate-in zoom-in duration-500">
						<CheckCircle2 className="h-10 w-10 text-green-600 dark:text-green-400" />
					</div>
				</div>

				{/* Message */}
				<div className="space-y-2">
					<h2 className="text-2xl font-semibold text-foreground">
						Thank You
					</h2>
					<p className="text-muted-foreground">
						Your interview is now complete. Our team will be in touch once your
						strategy is ready.
					</p>
				</div>
			</div>
		</div>
	);
}
